import { useState } from "react";

export function useChartLegend(seriesKey) {
  const [state, setState] = useState(() => ({ key: seriesKey, hidden: new Set() }));
  // A pending refresh has no series identity yet; retain the user's choices.
  if (seriesKey !== null && state.key !== seriesKey) {
    setState({ key: seriesKey, hidden: new Set() });
  }

  function toggle(id) {
    setState((previous) => {
      const hidden = new Set(previous.hidden);
      if (hidden.has(id)) hidden.delete(id);
      else hidden.add(id);
      return { ...previous, hidden };
    });
  }

  return [state.hidden, toggle];
}

export function ChartLegendToggle({ className, visible, onToggle, children }) {
  return (
    <button
      type="button"
      className={className}
      aria-pressed={visible}
      onClick={onToggle}
      style={{
        background: "none", border: 0, padding: 0, font: "inherit", color: "inherit",
        cursor: "pointer", textDecoration: visible ? "none" : "line-through",
        opacity: visible ? 1 : 0.45,
      }}
    >
      {children}
    </button>
  );
}
